import { useEffect, useState } from 'react';
import { getUserSettings } from '../api/settingsApi';

export const useBackgroundImage = () => {
  const [backgroundImage, setBackgroundImage] = useState<string>('none');

  useEffect(() => {
    const loadBackgroundImage = async () => {
      try {
        const settings = await getUserSettings();
        setBackgroundImage(settings.backgroundImage || 'none');
      } catch (error) {
        console.error('Failed to load background image setting:', error);
        setBackgroundImage('none');
      }
    };

    loadBackgroundImage();
  }, []);

  const getBackgroundClass = () => {
    if (backgroundImage === 'none') return '';
    return `background-${backgroundImage}`;
  };

  return {
    backgroundImage,
    backgroundClass: getBackgroundClass(),
    setBackgroundImage
  };
};